/**
 * https://mui.com/material-ui/material-icons/?query=arrow
 * src/theme/iconfont/MaterialIcons-Regular.svg
 * https://fonts.google.com/icons
 * @description Material UI Icons mapping for MultiMediaWizard
 */
const icons = {
  exit: 'exit_to_app',
  previous: 'keyboard_arrow_left',
  next: 'keyboard_arrow_right',
  submit: 'play_arrow',
  warning_mark: 'error_outline',
  remove: 'cancel',
  device: 'stay_current_landscape',
  location: 'public',
  warning_duplicate: 'warning',
  check_mark: 'check_circle',
  add: 'add_circle',
  error: 'error',
  filter: 'filter_list',
  video: 'movie',
  image: 'photo_size_select_actual',
  playlist: 'playlist_play',
  sign: 'tv',
  arrow_upward: 'arrow_upward',
  arrow_downward: 'arrow_downward',
  arrow_forward: 'arrow_forward',
  arrow_back: 'arrow_back',
  search: 'search',
  lock_outline: 'lock_outline',
  invisible: '0',
};
const className = 'material-icons';
const notMuiClassName = 'not-mui-icon';

export default { icons, className, notMuiClassName };
